<!--
 * @Author: 王文龙
 * @Date: 2024-12-09 14:20:38
 * @FileDescription: 复制文本组件
-->
<template>
  <span class="copy" @click="copyText(props.text)">复制</span>
</template>

<script setup>
import { copyText } from "@/utils/js-methods";
const props = defineProps({
  text: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.copy {
  margin-left: 8px;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}
</style>
